var App = App || {};
(function() {
	let self = App.menu = {

		menu_current: $(),
		menu_current_trigger: $(),
		_hoverLeaveTimer: null,
		_highlightedIndex: -1,
		_wheelHandler: null,

		_clearHoverTimer: function () {
			if (self._hoverLeaveTimer) {
				clearTimeout(self._hoverLeaveTimer);
				self._hoverLeaveTimer = null;
			}
		},

		getElCoord: function (el) {
			const $el = (el && el.jquery) ? el : $(el);
			if (!$el.length) return null;

			if ($el[0] === window) {
				const $w = $(window);
				const left = $w.scrollLeft();
				const top  = $w.scrollTop();
				const w    = $w.width();
				const h    = $w.height();
				return { x1: left, y1: top, x2: left + w, y2: top + h, width: w, height: h };
			}

			if ($el[0] === document) {
				const wDoc = $(document).width();
				const hDoc = $(document).height();
				return { x1: 0, y1: 0, x2: wDoc, y2: hDoc, width: wDoc, height: hDoc };
			}

			const off = $el.offset();
			const w   = $el.outerWidth();
			const h   = $el.outerHeight();

			return {
				x1: off.left,
				y1: off.top,
				x2: off.left + w,
				y2: off.top + h,
				width: w,
				height: h
			};
		},

		_escapeAttr: function (s) {
			return String(s).replace(/'/g, "\\'");
		},

		_getMenuByTrigger: function (trigger) {
			if (!trigger || !trigger.length) return $();
			let id = trigger.attr('data-menu-container');
			if (!id) return $();
			return $('#menuContainer').find('#' + self._escapeAttr(id));
		},

		_getCoordsForTrigger: function (trigger) {
			if (!trigger || !trigger.length) return null;
			return self.getElCoord(trigger);
		},

		_getOffsets: function () {
			let t = (self.menu_current_trigger && self.menu_current_trigger.length) ? self.menu_current_trigger : $();
			if (!t.length) return { dx: 0, dy: 0 };
			let dx = parseFloat(t.attr('data-menu-offset-x'));
			let dy = parseFloat(t.attr('data-menu-offset-y'));
			if (isNaN(dx)) dx = 0;
			if (isNaN(dy)) dy = 0;
			return { dx: dx, dy: dy };
		},

		_getViewportBox: function () {
			const $w = $(window);
			const x1 = $w.scrollLeft();
			const y1 = $w.scrollTop();
			const w  = $w.width();
			const h  = $w.height();
			return { x1: x1, y1: y1, x2: x1 + w, y2: y1 + h, w: w, h: h };
		},

		_getAlign: function () {
			let t = (self.menu_current_trigger && self.menu_current_trigger.length) ? self.menu_current_trigger : $();
			if (!t.length) return 'left';
			let a = (t.attr('data-menu-align') || '').toLowerCase();
			if (a !== 'right' && a !== 'center' && a !== 'auto') a = 'left';
			return a;
		},

		_getMinWidthFromTrigger: function () {
			let t = (self.menu_current_trigger && self.menu_current_trigger.length) ? self.menu_current_trigger : $();
			if (!t.length) return false;
			return (t.attr('data-menu-min-width') || '').toLowerCase() === 'trigger';
		},

		_getScrollParents: function ($el) {
			let res = [];
			if (!$el || !$el.length) return res;
			$el.parents().each(function () {
				let $p = $(this);
				let overflowY = ($p.css('overflow-y') || '').toLowerCase();
				let overflow  = ($p.css('overflow')   || '').toLowerCase();
				if (/(auto|scroll)/.test(overflowY) || /(auto|scroll)/.test(overflow)) {
					res.push($p);
				}
			});
			return res;
		},

		_getMenuItems: function () {
			if (!self.menu_current.length) return $();
			return self.menu_current.find('.menu__item');
		},

		_setHighlight: function (index) {
			let $items = self._getMenuItems();
			if (!$items.length) return;
			$items.removeClass('menu__item-hl');
			index = ((index % $items.length) + $items.length) % $items.length;
			self._highlightedIndex = index;
			$items.eq(index).addClass('menu__item-hl');
		},

		_clearHighlight: function () {
			self._highlightedIndex = -1;
			if (self.menu_current.length) {
				self.menu_current.find('.menu__item-hl').removeClass('menu__item-hl');
			}
		},

		_activeIndex: function () {
			let $items = self._getMenuItems();
			let idx = -1;
			$items.each(function (i) {
				if ($(this).hasClass('menu__item-active')) { idx = i; return false; }
			});
			return idx;
		},

		_isHoverTrigger: function (trigger) {
			if (!trigger || !trigger.length) return false;
			return (trigger.attr('data-menu-trigger') || '').toLowerCase() === 'hover';
		},

		_hideOthers: function (exceptMenu) {
			$('#menuContainer').find('.menu.menu-active').each(function () {
				let $m = $(this);
				if (exceptMenu && exceptMenu.length && $m.is(exceptMenu)) return;
				$m.removeClass('menu-active').hide();
				$('[data-menu-container="' + $m.attr('id') + '"]').removeClass('has-menu-active');
			});
			if (self.menu_current && self.menu_current.length) {
				if (!exceptMenu || !exceptMenu.length || !self.menu_current.is(exceptMenu)) {
					if (self.menu_current_trigger && self.menu_current_trigger.length) {
						self.menu_current_trigger.removeClass('has-menu-active');
						self.menu_current_trigger.blur();
					}
					self.menu_current = $();
					self.menu_current_trigger = $();
				}
			}
		},

		_setMenuPosition: function (withDisplay) {
			if (!self.menu_current.length || !self.menu_current_trigger.length) return false;

			let coords = self._getCoordsForTrigger(self.menu_current_trigger);
			if (!coords) return false;

			let o = self._getOffsets();
			let align = self._getAlign();

			let menuX = coords.x1;
			let menuY = coords.y2;

			if (align === 'right') {
				menuX = coords.x2 - self.menu_current.outerWidth();
			} else if (align === 'center') {
				menuX = Math.round((coords.x1 + coords.x2) / 2 - self.menu_current.outerWidth() / 2);
			} else if (align === 'auto') {
				let tryX = coords.x1;
				let vw = self._getViewportBox();
				let mw = self.menu_current.outerWidth();
				if (tryX + o.dx + mw > vw.x2 - 8) {
					menuX = coords.x2 - mw;
				} else {
					menuX = tryX;
				}
			}
			menuX += o.dx;
			menuY += o.dy;

			if (self._getMinWidthFromTrigger()) {
				let trigW = self.menu_current_trigger.outerWidth();
				if (trigW && self.menu_current.outerWidth() < trigW) {
					self.menu_current.css({'min-width': trigW + 'px'});
				}
			}

			if (withDisplay) {
				self.menu_current
					.css({'top': menuY+'px', 'left': menuX+'px', 'display': 'flex'})
					.addClass('menu-active');
			} else {
				self.menu_current.css({'top': menuY+'px', 'left': menuX+'px'});
			}

			let vp = self._getViewportBox();
			let mw = self.menu_current.outerWidth();
			let mh = self.menu_current.outerHeight();
			let clampX = menuX;
			let clampY = menuY;

			if (clampX + mw > vp.x2 - 8) clampX = vp.x2 - 8 - mw;
			if (clampX < vp.x1 + 8)      clampX = vp.x1 + 8;

			if (clampY + mh > vp.y2 - 8) clampY = Math.max(vp.y1 + 8, coords.y1 - mh - o.dy);
			if (clampY < vp.y1 + 8)      clampY = vp.y1 + 8;

			if (clampX !== menuX || clampY !== menuY) {
				self.menu_current.css({'top': clampY + 'px', 'left': clampX + 'px'});
			}

			return true;
		},

		init: function() {
			let toggle = $(document).find('[data-menu-container]');
			toggle.each(function () {
				let $trigger = $(this);
				let menu = self._getMenuByTrigger($trigger);
				if (!menu.length) return;

				if (self._isHoverTrigger($trigger)) {
					// --- click на hover-тригері ---
					$trigger.off('click.appmenu').on('click.appmenu', function (e) {
						e.preventDefault();
						e.stopPropagation();

						if (menu.hasClass('menu-active')) {
							self.hide();
						} else {
							self._clearHoverTimer();
							self._hideOthers(menu);
							self.menu_current_trigger = $trigger;
							self.menu_current = menu;
							self.show();
						}
					});

					// --- hover ---
					$trigger.off('mouseenter.appmenu').on('mouseenter.appmenu', function () {
						self._clearHoverTimer();
						self._hideOthers(menu);
						self.menu_current_trigger = $trigger;
						self.menu_current = menu;
						self.show();
					});

					$trigger.off('mouseleave.appmenu').on('mouseleave.appmenu', function () {
						self._hoverLeaveTimer = setTimeout(function () {
							self.hide();
						}, 100);
					});

					menu.off('mouseenter.appmenu').on('mouseenter.appmenu', function () {
						self._clearHoverTimer();
					});

					menu.off('mouseleave.appmenu').on('mouseleave.appmenu', function () {
						self._hoverLeaveTimer = setTimeout(function () {
							self.hide();
						}, 100);
					});

				} else {
					// --- click режим ---
					$trigger.off('click.appmenu').on('click.appmenu', function (e) {
						e.preventDefault();
						e.stopPropagation();

						if (menu.hasClass('menu-active')) {
							self.hide();
						} else {
							self._hideOthers(menu);
							self.menu_current_trigger = $trigger;
							self.menu_current = menu;
							self.show();
						}
					});
				}
			});

			$(document).off('click.appmenu').on('click.appmenu', function () {
				self.hide();
			});

			$('#menuContainer').off('click.appmenu').on('click.appmenu', function (e) {
				e.stopPropagation();
			});

			$(document).off('keydown.appmenu').on('keydown.appmenu', function (e) {
				if (e.key === 'Escape') { self.hide(); return; }

				if (!self.menu_current.length || !self.menu_current.hasClass('menu-active')) return;

				let $items = self._getMenuItems();
				if (!$items.length) return;
				let len = $items.length;
				let cur = self._highlightedIndex < 0 ? self._activeIndex() : self._highlightedIndex;

				switch (e.key) {
					case 'ArrowDown':
						e.preventDefault();
						self._setHighlight(cur < 0 ? 0 : cur + 1);
						break;
					case 'ArrowUp':
						e.preventDefault();
						self._setHighlight(cur < 0 ? len - 1 : cur - 1);
						break;
					case 'Home':
						e.preventDefault();
						self._setHighlight(0);
						break;
					case 'End':
						e.preventDefault();
						self._setHighlight(len - 1);
						break;
					case 'Tab':
						e.preventDefault();
						self._setHighlight(cur < 0 ? 0 : cur + (e.shiftKey ? -1 : 1));
						break;
					case 'Enter':
						if (cur >= 0) {
							$items.eq(cur).trigger('click');
							self.hide();
						}
						break;
				}
			});

			$(window).off('scroll.appmenu resize.appmenu').on('scroll.appmenu resize.appmenu', function () {
				if (!self.menu_current.length || !self.menu_current.hasClass('menu-active')) return;
				self.reposition();
			});
		},

		show: function () {
			if (!self.menu_current.length || !self.menu_current_trigger.length) return;

			if (!self.menu_current.hasClass('menu-active')) {
				self.menu_current_trigger.addClass('has-menu-active');
				self._setMenuPosition(true);

				self.menu_current_trigger[0].blur();
				self.menu_current.attr('tabindex', '-1')[0].focus({ preventScroll: true });

				self.menu_current.find('.menu__item').off('mouseenter.appmenu-hl').on('mouseenter.appmenu-hl', function () {
					self._clearHighlight();
				});

				$(window).off('focus.appmenu-refocus').on('focus.appmenu-refocus', function () {
					if (self.menu_current.length && self.menu_current.hasClass('menu-active')) {
						self.menu_current[0].focus({ preventScroll: true });
					}
				});

				self._highlightedIndex = -1;
				if (self._wheelHandler) window.removeEventListener('wheel', self._wheelHandler, { passive: false });
				self._wheelHandler = function (e) {
					if (!self.menu_current.length || !self.menu_current.hasClass('menu-active')) return;
					e.preventDefault();
					let $items = self._getMenuItems();
					if (!$items.length) return;
					let cur = self._highlightedIndex < 0 ? self._activeIndex() : self._highlightedIndex;
					let next = cur < 0
						? (e.deltaY > 0 ? 0 : $items.length - 1)
						: cur + (e.deltaY > 0 ? 1 : -1);
					self._setHighlight(next);
				};
				window.addEventListener('wheel', self._wheelHandler, { passive: false });

				if (self._scrollParents && self._scrollParents.length) {
					for (let i = 0; i < self._scrollParents.length; i++) {
						self._scrollParents[i].off('scroll.appmenu-sp');
					}
				}
				self._scrollParents = self._getScrollParents(self.menu_current_trigger);
				for (let i = 0; i < self._scrollParents.length; i++) {
					self._scrollParents[i].on('scroll.appmenu-sp', function () {
						if (!self.menu_current.length || !self.menu_current.hasClass('menu-active')) return;
						self.reposition();
					});
				}
			}
		},

		reposition: function () {
			if (!self.menu_current.length || !self.menu_current_trigger.length) return;
			self._setMenuPosition(false);
		},

		hide: function () {
			self._clearHighlight();
			$(window).off('focus.appmenu-refocus');
			if (self._wheelHandler) {
				window.removeEventListener('wheel', self._wheelHandler, { passive: false });
				self._wheelHandler = null;
			}
			if (self.menu_current && self.menu_current.length) {
				self.menu_current.removeAttr('tabindex');
				self.menu_current.find('.menu__item').off('mouseenter.appmenu-hl');
			}

			if (self.menu_current && self.menu_current.length) {
				self.menu_current.removeClass('menu-active').hide();
			}
			if (self.menu_current_trigger && self.menu_current_trigger.length) {
				self.menu_current_trigger.removeClass('has-menu-active');
				self.menu_current_trigger.blur();
			}

			if (self._scrollParents && self._scrollParents.length) {
				for (let i = 0; i < self._scrollParents.length; i++) {
					self._scrollParents[i].off('scroll.appmenu-sp');
				}
			}
			self._scrollParents = null;

			self.menu_current = $();
			self.menu_current_trigger = $();
		},

		onload: function () {
			self.init();
		}
	}
})();
$(App.menu.onload);